module.exports = __webpack_public_path__ + "img/RajadaVentoBlack.a0396875.svg";